import {Defaultable} from 'Core/models/Default';
import * as E from 'fp-ts/lib/Either';
import {Eq} from 'fp-ts/lib/Eq';
import {identity} from 'fp-ts/lib/function';
import {pipe} from 'fp-ts/lib/pipeable';
import {getEitherValue} from 'Shared/components/ValidatablePhoneInput';

export type Validatable<TInvalid, TValid> = E.Either<TInvalid, TValid>;

export const unwrapValidatableWithDefault = <T>() => (value: Validatable<Defaultable<T>, T>) =>
  pipe(
    value,
    E.fold(getEitherValue, identity)
  );

export const eqValid = <TInvalid, TValid>(
  eqInvalid: Eq<TInvalid>,
  eqValid: Eq<TValid>
): Eq<Validatable<TInvalid, TValid>> => E.getEq(eqInvalid, eqValid);
